import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import s from '../Inspection.css';

// Five stars as radio-like buttons (keyboard and screen reader friendly), 44 px targets.
export function StarsInput({ value, onChange, disabled, label }) {
  const { formatMessage } = useIntl();
  return (
    <fieldset className={s.stars} disabled={disabled}>
      <legend className={s.srOnly}>{label || formatMessage(messages.inspReviewRating)}</legend>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          className={cx(s.starButton, value >= star && s.starOn)}
          aria-pressed={value === star}
          aria-label={formatMessage(messages.inspStarLabel, { count: star })}
          onClick={() => onChange(star)}
        >{'★'}</button>
      ))}
    </fieldset>
  );
}

StarsInput.propTypes = { value: PropTypes.number, onChange: PropTypes.func, disabled: PropTypes.bool, label: PropTypes.string };
StarsInput.defaultProps = { value: 0, onChange: () => {}, disabled: false };

export default withStyles(s)(StarsInput);
